import { lazy } from 'react';

export const ReviewFundingDocumentForm = lazy(
  () => import('./ReviewFundingDocumentForm'),
);
